import { useQuery } from 'react-query';
import { RemoteNudgesRepo } from './NudgesRepo';

const keys = ['nudges'];
const nudgeRepo = new RemoteNudgesRepo();

export const fetchNudges = async () => {
  const { data } = await nudgeRepo.fetchNudges();
  return data;
};

export function useNudges() {
  return useQuery(keys, fetchNudges);
}
